appExperimente.controller('RefundCardController', ['$rootScope', '$scope', '$http', '$uibModal', '$window', '$document', function ($rootScope, $scope, $http, $uibModal, $window, $document) {
  $scope.LOADING = $scope.hasActiveEstablishment();
  $scope.searchResult = null;
  $scope.status = 2;
  $scope.produtos = null;
  $scope.produto = 31;
  $scope.statusList = [
    {value: 1, name: 'Pagos'},
    {value: 2, name: 'Próximos'}
  ];

  $scope.init = function () {
    $http({
      method: 'GET',
      url: '/portal/app/UI-Comum/trial/ec/cadastro/consultar-credenciamento',
      headers: {'Content-Type': 'text/plain'}
    }).success(function (data) {
      $scope.LOADING = false;
      $scope.produtos = data;
    }).error(function (data) {
      $scope.LOADING = false;
    });

    // Paginação - início
    if ($scope.urlQueryValue('pagina')) {
      var currentPage = parseInt($scope.urlQueryValue('pagina'));
      $scope.guiasPage = currentPage;
      $scope.transacoesPage = currentPage;
    } else {
      $scope.guiasPage = 1;
      $scope.transacoesPage = 1;
    }
  };

  $scope.$on(constants.EVENTS.ESTABLISHMENT_UPDATED, function (event) {
    $scope.produto = null;
    $scope.produtos = null;
    $scope.searchResult = null;
    $scope.init();
  });

  $scope.consultar = function () {
    $scope.LOADING = true;
    $scope.searchResult = [];
    $http({
      url: '/portal/app/UI-Comum/trial/ec/reembolso/resumo/' + $scope.produto + '/' + $scope.status,
      method: 'GET',
      headers: {'Content-Type': 'text/plain'}
    }).success(function (data) {
      $scope.LOADING = false;
      $scope.searchResult = data.guias;
    }).error(function () {
      $scope.LOADING = false;
      $scope.searchResult = null;
    });
    return false;
  };

  $scope.hasProduct = function () {
    return $scope.produtos !== null && $scope.produtos.length > 0 && $scope.LOADING === false;
  };

  $scope.hasContent = function () {
    return $scope.searchResult !== null && $scope.searchResult.length > 0 && $scope.LOADING === false;
  };

  $scope.hasNoContent = function () {
    return ($scope.searchResult === null || $scope.searchResult.length <= 0) && $scope.LOADING === false || !$scope.hasActiveEstablishment();
  };

  $scope.verReembolsoCompleto = function () {
    $window.location.href = 'reembolso.html';
  };

  $scope.init();

  if (constants.SETTINGS.DEBUG) {
    $scope.exposeScope('RefundCardController', $scope);
  }

}]);
